import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators';

@customElement('error-404-page')
export class Error404Page extends LitElement {
    static amplitude_callsite: string = '404 Page';

    render() {
        return html`
            <error-page-fragment
                heading="Uh oh. We’re Lost"
                description="Sorry, we can’t find the map you are looking for. We suggest you go to your my maps page while we are fixing the problem."
            >
            </error-page-fragment>
        `;
    }
}
